import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appSocialDownload]',
})
export class SocialImageDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
